import React from 'react'
import { Form } from 'react-bootstrap'
import useParticipate from './use-participate'

const ParticipateInput = ({
    discussionId
}) => {
    const [content, setContent] = React.useState('')
    const { participate, isLoading } = useParticipate({ discussionId, onnSuccess: () => setContent('')})
    const onKeyDown = React.useCallback((e) => {
        if (e.key === 'Enter') {
            participate(content)
        }
    }, [participate, content])
    return (
        <Form.Control
            disabled={isLoading}
            value={content}
            onChange={e => setContent(e.target.value)}
            placeholder='Aa'
            onKeyDown={onKeyDown}
        />
    )
}

export default ParticipateInput
